import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import store from "@/store";

const db = firebase.initializeApp({
  apiKey: "AIzaSyBy82Ah_N1cI5UWi5betTg_rE6_cdNqjZA",
  authDomain: "ppyatc-prod.firebaseapp.com",
  databaseURL: "https://ppyatc-prod.firebaseio.com",
  projectId: "ppyatc-prod",
  storageBucket: "ppyatc-prod.appspot.com",
  messagingSenderId: "159566040192"
});

db.login = (email, password) => {
  return firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then(res => {
      return firebase
        .firestore()
        .collection("users")
        .doc(res.user.uid)
        .get();
    })
    .then(res => {
      if (res.exists) store.commit("setCurrentUser", res.data());
    })
    .catch(err => store.commit("setError", err.message));
};

db.signOut = () => {
  return firebase
    .auth()
    .signOut()
    .then(() => store.commit("setCurrentUser", null))
    .catch(err => store.commit("setError", err.message));
};

export default db;
